export const ROUTES = {
  HOME: '/',
  /** A single vessel's detail view. The static routes out-rank it, so `/unauthorized` still wins. */
  VESSEL: '/:vesselId',
  UNAUTHORIZED: '/unauthorized',
} as const;

export const vesselPath = (vesselId: string) => `/${vesselId}`;
